export type authModalState = {
  modalContent: 'login' | 'registration' | 'forgot' | null;
};

export const OPEN_AUTH_MODAL = 'auth/OPEN_AUTH_MODAL';
export const CLOSE_AUTH_MODAL = 'auth/CLOSE_AUTH_MODAL';
